import { IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { removeSnackbar } from 'src/domains/global/actions'
import { AppState } from 'src/store'



let displayed: string[] = []

const Notifier: React.FC = () => {
    const dispatch = useDispatch()

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()

    const notifications = useSelector(
        (state: AppState) => state.global.view.notifications
    )

    const storeDisplayed = (id: string) => {
        displayed = [...displayed, id]
    }

    const removeDisplayed = (id: string) => {
        displayed = [...displayed.filter(key => id !== key)]
    }

    const clickSnackbarDismiss = (key: string) => {
        closeSnackbar(key)
    }

    const action = (key: string) => (
        <>
            <IconButton
                size='small'
                color='inherit'
                onClick={() => clickSnackbarDismiss(key)}>
                <Close fontSize='small' />
            </IconButton>
        </>
    )

    useEffect(() => {
        notifications.forEach(
            ({ key, message, options = {}, dismissed = false }) => {
                if (dismissed) {
                    closeSnackbar(key)
                    return
                }

                if (displayed.includes(key)) return

                options = {
                    ...options,
                    action: action(key),
                }

                enqueueSnackbar(message, {
                    key,
                    ...options,
                    onClose: (event, reason, myKey) => {
                        if (options.onClose) {
                            options.onClose(event, myKey, reason)
                        }
                    },
                    onExited: (event, myKey: string) => {
                        dispatch(removeSnackbar(myKey))
                        removeDisplayed(myKey)
                    },
                })

                // keep track of snackbars that we've displayed
                storeDisplayed(key)
            }
        )
    }, [notifications, closeSnackbar, enqueueSnackbar, dispatch])

    return null
}

export default Notifier
